import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

// Connects to data-controller="preview-content"
export default class extends Controller {
  static targets = ["editor", "preview", "previewLink", "editorLink"]
  static values = {
    previewUrl: String
  }

  connect() {
    this.form = this.element.closest("form")
  }

  togglePreview() {
    this.previewTarget.innerHTML = "Loading preview..."

    this.fetchPreview()

    this.editorTarget.classList.toggle("hidden")
    this.previewTarget.classList.toggle("hidden")
    this.previewLinkTarget.classList.toggle("hidden")
    this.editorLinkTarget.classList.toggle("hidden")
  }

  toggleEditor() {
    this.editorTarget.classList.toggle("hidden")
    this.previewTarget.classList.toggle("hidden")
    this.previewLinkTarget.classList.toggle("hidden")
    this.editorLinkTarget.classList.toggle("hidden")
  }

  async fetchPreview() {
    let formData = new FormData(this.form)
    formData.delete("_method")

    const response = await post(this.previewUrlValue, {
      body: formData
    })

    if (response.ok) {
      const body = await response.json;
      this.previewTarget.innerHTML = body.html
      window.mermaid.run();
    } else {
      this.previewTarget.innerHTML = "Failed to fetch preview"
    }
  }
}
